import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Home from '../pages/Home';
import Layout from '../components/Layout';
import LoginPage from '../pages/Login';
import ForgotPasswordPage from '../pages/ForgotPassword';
import SignUpPage from '../pages/SignUp';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyAccount from '../pages/Account';
import CollectionPage from '../pages/Collection';
import ResetPasswordPage from '../pages/ResetPassword';
import ProductDetail from '../pages/ProductDetail';
import Docload from '../pages/Docload';
import Faqs from '../pages/Faqs';
import Blogs from '../pages/Blogs';
import BlogDet from '../components/BlogDet';
import CartPage from '../pages/CartPage';
import CheckoutPage from '../pages/CheckoutPage';
import BlogEditor from '../components/BlogEditor';
import Contactus from '../pages/Contactus';
import OrderTracking from '../pages/OrderTracking';
import SearchResults from "../pages/SearchResults"
import ConfirmOrderMessage from '../pages/ConfirmOrderMessage';

// Protected route component for private routes
const PrivateRoute = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.auth.user);
  return isAuthenticated ? children : <Navigate to="/login" />;
};

// Protected route component for auth routes (login, signup, etc.)
const AuthRoute = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.auth.user);
  return !isAuthenticated ? children : <Navigate to="/" />;
};

const AppRoutes = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/collections/:collectionName" element={<CollectionPage />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/Docload/:policyType" element={<Docload />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/blogs"element={<Blogs />} />
          <Route path="/blogs/:id" element={<BlogDet />} />
          <Route path="/contact-us" element={<Contactus />} />
          <Route path="/search-details/:searchString" element={<SearchResults />} />
          <Route path="/confirm-order-message" element={ < ConfirmOrderMessage /> } />
          {/* <Route path="/search" element={<SearchPage />} /> */}
          <Route
            path="/myorders"
            element={
             
                <OrderTracking />
             
            }
          />
          {/* Auth Routes - only accessible if the user is NOT logged in */}
          
          <Route
            path="/login"
            element={
              <AuthRoute>
                <LoginPage />
              </AuthRoute>
            }
          />
          <Route
            path="/register"
            element={
              <AuthRoute>
                <SignUpPage />
              </AuthRoute>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <AuthRoute>
                <ForgotPasswordPage />
              </AuthRoute>
            }
          />
          <Route
            path="/reset-password"
            element={  
                <ResetPasswordPage />
            }
          />

          {/* Private Routes - only accessible if the user is logged in */}
          {/* Add private pages here as needed */}
            <Route
              path="/account"
              element={
                <PrivateRoute>
                  <MyAccount />
                </PrivateRoute>
              }
            />
           <Route
            path="/blogEditor/:id"
            element={
              <PrivateRoute>
                <BlogEditor />
              </PrivateRoute>
            }
          />
          <Route
            path="/blogEditor"
            element={
              <PrivateRoute>
                <BlogEditor />
              </PrivateRoute>
            }
          />
          
         
        </Routes>
      </Layout>
      <ToastContainer />
    </Router>
  );
};

export default AppRoutes;
